module.exports = __webpack_public_path__ + "media/svg-new/svg-c-disciplinas-4e8960e3.svg";